export const MEDICAL_UW_URL = {

    annuitant: {
        lifestyle: '/home/lifestyle',
        medicalConditions: '/home/medical-conditions',
        AMC: '/home/add-medical-condition',
        diabetes: '/home/medical-condition-content',
        DMC: '/home/medical-condition-questionnaire',
        ADL: '/home/activities-of-daily-living',
        doctorDetails: "/home/doctor's-details"
    },
    dependant: {
        dependantLifestyle: '/home/dependant-lifestyle',
        dependantMedicalConditions: '/home/dependant-medical-conditions',
        dependantAMC: '/home/dependant-add-medical-condition',
        dependantDiabetes: '/home/dependant-medical-condition-content',
        dependantDMC: '/home/dependant-medical-condition-questionnaire',
        dependantADL: '/home/dependant-activities-of-daily-living',
        dependantDoctorDetails: "/home/dependant-doctor's-details"
    }

};

export const MEDICAL_UW_HO_URL = {

    annuitant: {
        lifestyle: '/ho-underwriting/lifestyle',
        medicalConditions: '/ho-underwriting/medical-conditions',
        AMC: '/ho-underwriting/add-medical-condition',
        diabetes: '/ho-underwriting/medical-condition-content',
        DMC: '/ho-underwriting/medical-condition-questionnaire',
        ADL: '/ho-underwriting/activities-of-daily-living',
        doctorDetails: '/ho-underwriting/doctor\'s-details'
    },
    dependant: {
        dependantLifestyle: '/ho-underwriting/dependant-lifestyle',
        dependantMedicalConditions: '/ho-underwriting/dependant-medical-conditions',
        dependantAMC: '/ho-underwriting/dependant-add-medical-condition',
        dependantDiabetes: '/ho-underwriting/dependant-medical-condition-content',
        dependantDMC: '/ho-underwriting/dependant-medical-condition-questionnaire',
        dependantADL: '/ho-underwriting/dependant-activities-of-daily-living',
        dependantDoctorDetails: '/ho-underwriting/dependant-doctor\'s-details'
    }

};

export const UW_WEB_ANALYTICS_CONST = {
    healthRisk: "Health risks"
};

export const BRMS_WEB_ANALYTICS_CONST_LIST = [
    "How tall are you",
    "What do you weigh",
    "What do you weigh",
    "Have you been a regular daily smoker for the last 10 years",
    "What do you smoke",
    "When did you start smoking",
    "When did you stop smoking",
    "How much alcohol do you drink in a week",
    "How many units of alcohol do you drink in a week"
];